import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiBilling } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const getAccountCashierInfo = () => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        uid:  userData.smsAuth.userId,
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiBilling.post('/services/getAccountCashierInfo', params, config)
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setAccountCashierInfo,
                value: {
                    cashierInfo: data
                },
            })
        }
    } catch (e) {
        console.error('get account cashier info failed', e)
    }

}

export default getAccountCashierInfo
